export enum RestricaoConta {
  Colaborador = 'contaColaborador',
  ColaboradorPJ = 'colaboradorPj',
  ColaboradorMei = 'colaboradorMei',
}